// extracted by mini-css-extract-plugin
module.exports = {"header":"DashboardFilter_header__nJFMj","box":"DashboardFilter_box__4Jkb9","sliderHeader":"DashboardFilter_sliderHeader__yIxch"};